const styles = (theme) => ({
  label: {
    minWidth: 80,
  },
  container: {
    display: "flex",
    border: `1px solid ${theme.AppBGColor}`,
    borderRadius: "4px",
    flexWrap: "wrap",
    justifyContent: "space-between",
    padding: 8,
  },
  input: {
    marginRight: 8,
  },
  defaultInput: {
    margin: 0,
  },
  fieldContainer: {
    maxWidth: 200,
  },
  namefieldContainer : {
    maxWidth: 250
  }
});

export default styles;
